import axios from 'axios';
import {
  LOGIN_REQUEST,
  LOGIN_FAILED,
  LOGIN_SUCCESS,
  LOGOUT_FAILED,
  REGISTER_REQUEST,
  REGISTER_SUCCESS,
  REGISTER_FAILED,
  FORGOT_SUCCESS,
  FORGOT_FAILED,
  RESET_SUCCESS,
  RESET_FAILED,
  LOGOUT,
  DETAIL_AXI,
  DETAIL_AXI_INSENTIF,
  SET_PROFILE,
  SET_BANKS,
  SET_USER,
  SET_AXI_ID,
  TOKEN_SUPER_AXI
} from '@/stores/constants';
import {
  login,
  logout,
  registerNasabah,
  checkAuth,
  getProfileAxi,
  getDetailProfileByDetailAxiId,
  getDetailInsentif,
  forgotPassword,
  resetPassword,
  tokenValidation,
  registerMaxi,
  registerAxi,
  getBanks,
  getDetailAxiByNomorAxi,
  getProfileAxiByUserId,
  getProfileByUserId,
  updateProfile,
  updateAvatar,
  getAxiProfileToken,
  changePassword,
  getstatusverified

} from '@/services/auth';
import { token } from '@/services/token';

let refreshTokenPromise = null;

export default {
  namespaced: true,
  state: {
    credentials: {
      username: '',
      password: '',
      rememberMe: false,
    },
    user: {},
    forgot: {},
    reset: {},
    token: {},
    role: '',
    errorMessage: '',
    detailAxi: {},
    detailAxiInsentif: {},
    profile: {},
    banks: [],
    axi_id: '',
  },
  getters: {
    getCredencials: state => state.credentials,
    getBank: state => state.banks,
    getErrorMessage: state => state.errorMessage,
    getDetailAxi: state => state.detailAxi,
    getDetailAxiInsentif: state => state.detailAxiInsentif,
    getProfile: state => state.profile,
    getForgot: state => state.forgot,
    getReset: state => state.reset,
    getUser: () => sessionStorage.dicicilUser ? JSON.parse(window.atob(sessionStorage.dicicilUser)) : null,
    getUserRole: () => sessionStorage.dicicilUser ? JSON.parse(window.atob(sessionStorage.dicicilUser)).role.toLowerCase() : '',
    isLoggedIn: state => Boolean(state.token.accessToken) || Boolean(token.accessToken),
    getAxiId: state => state.axi_id,
  },
  mutations: {
    [LOGIN_REQUEST](state, credentials) {
      state.credentials = credentials
    },
    [LOGIN_FAILED](state, errorMessage) {
      state.errorMessage = errorMessage
    },
    [LOGIN_SUCCESS](state, user) {
      // const loginToken = user.access_token || ''
      // console.log(user);
      sessionStorage.setItem('dicicilUser', window.btoa(JSON.stringify(user)))
      state.user = user
      state.role = user.role
      state.token = {
        accessToken: user.access_token,
        accessTokenType: user.token_type,
        refreshToken: user.refresh_token,
      }
      token.accessToken = user.access_token
      token.accessTokenType = user.token_type
      token.refreshToken = user.refresh_token
    },
    [SET_USER](state, user) {
      // console.log("auth",user);
      sessionStorage.setItem('dicicilUser', window.btoa(JSON.stringify(user)))
      state.user = user
    },
    [LOGOUT](state) {
      state.user = null
      state.errorMessage = ''
      state.token = {}
      state.credentials = {
        username: '',
        password: '',
      }
      sessionStorage.removeItem('dicicilUser')
      sessionStorage.removeItem('user_id')
      token.clear()
    },
    [LOGOUT_FAILED](state, errorMessage) {
      state.errorMessage = errorMessage;
    },
    [REGISTER_REQUEST](state, user) {
      state.user = user;
    },
    [REGISTER_SUCCESS](state, user) {
      state.user = user;
    },
    [REGISTER_FAILED](state, errorMessage) {
      state.errorMessage = errorMessage;
    },
    [FORGOT_SUCCESS](state, forgot) {
      state.forgot = forgot;
    },
    [FORGOT_FAILED](state, errorMessage) {
      state.errorMessage = errorMessage;
    },
    [RESET_SUCCESS](state, forgot) {
      state.forgot = forgot;
    },
    [RESET_FAILED](state, errorMessage) {
      state.errorMessage = errorMessage;
    },
    [DETAIL_AXI](state, detailAxi) {
      state.detailAxi = detailAxi;
    },
    [DETAIL_AXI_INSENTIF](state, detailAxiInsentif) {
      state.detailAxiInsentif = detailAxiInsentif;
    },
    [SET_PROFILE](state, profile) {
      state.profile = profile;
    },
    [SET_BANKS](state, banks) {
      state.banks = banks;
    },
    [SET_AXI_ID](state, axi_id) {
      state.axi_id = axi_id;
    },
  },
  actions: {
    async login({ commit }, credentials = {}) {
      commit(LOGIN_REQUEST, credentials);

      try {
        const payload = {
          data: {
            attributes: credentials,
          },
        }
        const result = await login(payload)
        const { data } = result.data
        if (data.attributes.role === "Nasabah") {
          // const user = await getProfileAxiByUserId(data.id, data.attributes.token_type, TOKEN_SUPER_AXI)
          const { data : profile } = await getProfileByUserId(data.id, data.attributes.token_type, data.attributes.access_token)
          commit(LOGIN_SUCCESS, {
            ...data.attributes
          ,profile_id : profile.id
          })
        } else {
          //const user = await getProfileAxiByUserId(data.id, data.attributes.token_type, data.attributes.access_token)
          // commit(LOGIN_SUCCESS, {
          //   ...data.attributes,
          //   ...user.data.data[0],
          //   included: user.data.included
          // })
          commit(LOGIN_SUCCESS, {
            user_id: data.id,
            ...data.attributes,
            nomor_axi_id: credentials.email
          });
        }

      } catch (error) {
        commit(LOGIN_FAILED, error.response.data.message || error.response.data.errors[0].message);
        throw error;
      }
    },
    async getProfileDefault({ commit }, id) {
      return await getProfileAxi(id);
    },
    async checkAuth({ commit }) {
      try {
        const { data } = await checkAuth();
        return data;
      } catch (error) {
        if (error.response && error.response.status === 401) {
          commit(LOGOUT);
        }
        throw error
      }
    },
    async refreshToken({ rootState }) {
      const url = `${rootState.base_url_bff}/refresh-token`

      const method = 'POST'

      const headers = {
        'Accept': 'application/json',
        'Authorization': `Bearer ${token.accessToken}`
      }
      let formData = new FormData();
      formData.set('refresh_token', token.refreshToken);

      const config = {
        url,
        method,
        data: formData,
        headers,
      }
      try {
        const response = await axios(config)
        const data = response.data

        token.accessToken = data.access_token
        token.refreshToken = data.refresh_token
        token.accessTokenType = data.token_type

        return data
      } catch (e) {
        return e
      }
    },
    async updateProfile ({commit}, payload) {
      try {
        const { data } = await updateProfile(payload.profile_id, payload.data);
        return data;
      } catch (error) {
        throw error;
      }
    },
    async updateAvatar({ commit }, payload) {
      try {
        const { data } = await updateAvatar(payload.profile_id, payload.data)
        return data
      } catch (error) {
        throw error
      }
    },
    async changePassword({ commit }, payload) {
      try {
        const { data } = await changePassword(payload);
        return data;
      } catch (error) {
        throw error;
      }
    },
    async logout({ commit }) {
      try {
        await logout();
        commit(LOGOUT);
      } catch (error) {
        commit(LOGOUT_FAILED, error.response.data.message);
        throw error;
      }
    },
    async register({ commit }, payload) {
      commit(REGISTER_REQUEST, payload)
      try {
        const result = await registerNasabah(payload)
        const { data } = result.data
        commit(REGISTER_SUCCESS, data)
      } catch (error) {
        commit(REGISTER_FAILED, error.response.data.message);
        throw error;
      }
    },
    async registerMaxi({ commit }, payload) {
      commit(REGISTER_REQUEST, payload)
      try {
        let formData = new FormData()

        Object.keys(payload).forEach(key => {
          formData.append(key, payload[key])
        })
        let result = await registerMaxi(formData)
        const { data } = result.data
        commit(REGISTER_SUCCESS, data)
      } catch (error) {
        commit(REGISTER_FAILED, error.response.data.message);
        throw error;
      }
    },
    async registerAxi({ commit }, payload) {
      commit(REGISTER_REQUEST, payload)
      try {
        let formData = new FormData()

        Object.keys(payload).forEach(key => {
          formData.append(key, payload[key])
        })
        let result = await registerAxi(formData)
        const { data } = result.data
        commit(REGISTER_SUCCESS, data)
      } catch (error) {
        commit(REGISTER_FAILED, error.response.data.message);
        throw error;
      }
    },
    async fetchDetailAxi({ commit }, userId) {
      try {
        const result = await getDetailProfileByDetailAxiId(userId);
        const { data } = result.data;
        commit(DETAIL_AXI, data);
      } catch (error) {
        commit(REGISTER_FAILED, error.response.data.message);
        throw error;
      }
    },
    async fetchDetailAxiById({ commit }, userId) {
      try {
        const result = await getProfileAxiByUserId(userId);
        const { data } = result.data;
        commit(DETAIL_AXI, data);
      } catch (error) {
        commit(REGISTER_FAILED, error.response.data.message);
        throw error;
      }
    },
    async fetchForgotPassword({ commit }, payload = '') {
      try {
        const result = await forgotPassword(payload);
        const { data } = result.data;
        commit(FORGOT_SUCCESS, data);
      } catch (error) {
        commit(FORGOT_FAILED, error.response.data.message);
        throw error;
      }
    },
    async resetPassword({ commit }, payload = '') {
      try {
        const result = await resetPassword(payload);
        // console.log(result);
        const { data } = result.data;
        commit(RESET_SUCCESS, data);
        return result;
      } catch (error) {
        commit(RESET_FAILED, error);
        throw error;
      }
    },
    async tokenValidation({ commit }, payload = '') {
      try {
        const result = await tokenValidation(payload);
        // console.log(result);
        const { data } = result.data;
        commit(RESET_SUCCESS, data);
        return result;
      } catch (error) {
        commit(RESET_FAILED, error);
        throw error;
      }
    },
    async fetchProfile({ commit }, id) {
      try {
        const result = await getProfileAxi(id);
        const { data } = result.data;
        commit(SET_PROFILE, data);
      } catch (error) {
        throw error;
      }
    },
    async fetchDetailAxiByNomorAxi({ commit }, id) {
      try {
        let result = await getDetailAxiByNomorAxi(id)
        const { data } = result.data
        commit(DETAIL_AXI, data.length > 0 ? data[0] : {})
      } catch (error) {
        throw error;
      }
    },
    async fetchDetailInsentif({ commit }, id) {
      try {
        let result = await getDetailInsentif(id)
        const { data } = result.data
        commit(DETAIL_AXI_INSENTIF, data.length > 0 ? data[0] : {})
      } catch (error) {
        throw error;
      }
    },
    async setUser({ commit }, user) {
      try {
        commit(SET_USER, user)
        return true
      } catch (error) {
        throw error
      }
    },
    async fetchBanks({ commit }) {
      try {
        const result = await getBanks();
        const { data } = result.data;
        commit(SET_BANKS, data);
      } catch (error) {
        throw error;
      }
    },
    async getAxiProfileToken({ commit }) {
      try {
        const result = await getAxiProfileToken();
        const { data } = result.data;
        return data;
      } catch (error) {
        return error;
      }
    },
    setAxiId({ commit }, data) {
      commit(SET_AXI_ID, data);
    },

    async getstatusverified({ commit }) {
      try {
        const result = await getstatusverified();
        const { data } = result.data;
        // console.log(result.data)
        return data.verified_event_status;
      } catch (error) {
        return error;
      }
    },
  },
};
